import { Injectable } from '@angular/core';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Injectable()
export class FiDebugInfoService {
    constructor(private customerDataService: FiCustomerDataService) {}
    private infoItems: string[] = [];

    addInfo(info: string) {
        if (!this.canGetInfo()) return;
        const dateTime = new Date();
        let str =
            '<b>' +
            dateTime.getHours() +
            ':' +
            dateTime.getMinutes() +
            ':' +
            dateTime.getSeconds() +
            ':' +
            dateTime.getMilliseconds() +
            '</b> - ' +
            info;
        console.log('debugLog: ' + str);
        this.infoItems.push(str);
    }

    getInfo() {
        if (!this.canGetInfo()) return;
        return this.infoItems.join('<br>');
    }

    canGetInfo() {
        return this.customerDataService.isTestCustomer();
    }
}
